import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Checkbox, Grid, Typography } from "@mui/material";
import { convertToNLEuroFormat } from "../../../application/common/utils/helper";
const OfferLeadObject = ({ leadobject, setSelectedObjects, selectedObjects, }) => {
    const handleCheckboxChange = (leadObjectPrice) => {
        const existingIndex = selectedObjects.findIndex((record) => record.objectId === leadObjectPrice.objectId);
        if (existingIndex !== -1) {
            // If the record already exists, remove it
            const updatedRecords = [...selectedObjects];
            updatedRecords.splice(existingIndex, 1);
            setSelectedObjects(updatedRecords);
        }
        else {
            // If the record doesn't exist, add it
            setSelectedObjects((prevRecords) => [...prevRecords, leadObjectPrice]);
        }
    };
    return (_jsxs(Grid, { container: true, size: {
            lg: 12,
            xs: 12
        }, sx: {
            mx: "auto",
            borderRadius: "12px",
            background: "var(--n-primary-light, #F9F6FF)",
            padding: 2,
            boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.05), 0px 12px 12px 0px rgba(0, 0, 0, 0.04), 0px 26px 16px 0px rgba(0, 0, 0, 0.03), 0px 46px 19px 0px rgba(0, 0, 0, 0.01), 0px 73px 20px 0px rgba(0, 0, 0, 0.00)",
            maxWidth: "100%",
            overflow: "hidden",
            boxSizing: "border-box"
        }, children: [_jsxs(Grid, { size: {
                    lg: 3,
                    md: 3,
                    xs: 12
                }, sx: {
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "center", md: "flex-start" },
                    justifyContent: { xs: "center", md: "flex-start" },
                    gap: { xs: 1, md: 1 },
                    paddingTop: { xs: 0, md: "8px" }
                }, children: [_jsx(Box, { sx: { display: "flex", alignItems: "flex-start", paddingTop: { xs: 0, md: "4px" } }, children: leadobject.isContracted ? (_jsx(Checkbox, { disabled: true, checked: true })) : (_jsx(Checkbox, { checked: selectedObjects.some((obj) => obj.objectId === leadobject.id), onChange: () => handleCheckboxChange({
                                objectId: leadobject.id,
                                price: leadobject.price,
                                updatedPrice: leadobject.updatedPrice == undefined ||
                                    leadobject.updatedPrice == null ||
                                    leadobject.updatedPrice == 0
                                    ? leadobject.price
                                    : leadobject.updatedPrice,
                            }) })) }), _jsx(Box, { sx: { flex: 1 }, children: _jsx(Box, { component: "img", sx: {
                                maxWidth: { xs: "100%", md: "100%" },
                                maxHeight: "244px",
                                height: "auto",
                                objectFit: "contain",
                                objectPosition: "center center",
                            }, src: leadobject.imageUrl }) })] }), _jsxs(Grid, { size: {
                    lg: 4,
                    md: 4,
                    xs: 12
                }, sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    borderRight: {
                        xs: "0px",
                        md: "1px solid var(--n-teal-dark, #4D666E)",
                    },
                    borderBottom: {
                        xs: "1px solid var(--n-teal-dark, #4D666E)",
                        md: "0px",
                        lg: "0px",
                    },
                    paddingTop: { xs: 2, md: "8px" },
                    paddingX: { xs: 1, md: 2 },
                    maxWidth: "100%",
                    overflow: "hidden"
                }, children: [_jsx(Typography, { sx: {
                            color: "var(--n-jetblack, #312F2F)",
                            textAlign: "center",
                            paddingBottom: "8px",
                            width: "100%",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            wordBreak: "break-word",
                            maxWidth: "100%",
                        }, variant: "h6", children: leadobject.name }), _jsx(Typography, { sx: {
                            color: "var(--Status-Success, #2AA241)",
                            fontSize: "18px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "150%" /* 27px */,
                            letterSpacing: "1px",
                            paddingBottom: "16px",
                            width: "100%",
                            textAlign: "center",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%",
                        }, children: convertToNLEuroFormat(leadobject.price) }), _jsxs(Typography, { variant: "body1", sx: {
                            color: "var(--Neutral-600, #6C757D)",
                            paddingBottom: "8px",
                            width: "100%",
                            textAlign: "center",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%"
                        }, children: ["Dakvlakken: ", leadobject.totalRoofSurfaces] }), _jsxs(Typography, { variant: "body1", sx: {
                            color: "var(--Neutral-600, #6C757D)",
                            paddingBottom: "8px",
                            width: "100%",
                            textAlign: "center",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%"
                        }, children: ["Oppervlakte: ", leadobject.area] }), leadobject.statusLevel1Name === "Special" && (_jsx(Box, { sx: {
                            bgcolor: "#FFF3CD",
                            padding: 1,
                            borderRadius: 2,
                            width: "100%",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                        }, children: _jsx(Typography, { variant: "h4", sx: {
                                color: "#856404",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                textAlign: "center",
                                maxWidth: "100%"
                            }, children: leadobject.statusLevel1Name }) }))] }), _jsx(Grid, { size: {
                    lg: 5,
                    md: 5,
                    xs: 12
                }, sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingTop: { xs: 2, md: "8px" },
                    paddingX: { xs: 1, md: 2 },
                    maxWidth: "100%",
                    overflow: "hidden"
                }, children: leadobject.context && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", sx: {
                                color: "var(--Neutral-700, #495057)",
                                fontWeight: 600,
                                paddingBottom: "8px",
                                width: "100%",
                                textAlign: "center",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                maxWidth: "100%"
                            }, children: "Aanmeldprocedure:" }), _jsx(Typography, { variant: "body2", sx: {
                                color: "var(--Neutral-600, #6C757D)",
                                width: "100%",
                                textAlign: "center",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                maxWidth: "100%",
                                lineHeight: 1.6
                            }, children: leadobject.context })] })) })] }));
};
export default OfferLeadObject;
